import { render } from "./DeliveryScheduleForm.vue?vue&type=template&id=110c5574&scoped=true"
import script from "./DeliveryScheduleForm.vue?vue&type=script&lang=js"
export * from "./DeliveryScheduleForm.vue?vue&type=script&lang=js"

import "./DeliveryScheduleForm.vue?vue&type=style&index=0&id=110c5574&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110c5574"]])

export default __exports__